import React, { useState } from "react";
import "../Styles/login.css";

const Login = () => {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    console.log("Login submitted:", loginData);
    // TODO: Add your login API here
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    console.log("Reset link requested for:", forgotEmail);
    // TODO: Add your forgot password API here
  };

  return (
    <div className="login-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="login-left">
        <div className="login-logo">
        <img
            src="/assets/log-VHRD-logo.png"
            alt="Vanakkam HRD Logo"
            className="login-logo-img"
        />
        </div>

        <div className="login-illustration">
          <img src="/assets/log_img.png" alt="Vanakkam HRD" />
        </div>

        <div className="login-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="login-right">
        {view === "login" ? (
          <form className="login-form" onSubmit={handleLoginSubmit}>
            <h1 className="form-heading">Admin Login</h1>

            <p className="form-subheading">
              Enter your credentials to access the admin dashboard
            </p>

            <label className="form-label">User Email ID</label>

            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="Enter your Email ID"
              value={loginData.email}
              onChange={handleLoginChange}
              required
            />

            <label className="form-label">Password</label>

            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
              <img
                src="/assets/log_eye.png"
                alt="Toggle password visibility"
                className="password-eye-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>

            <button
              type="button"
              className="link-btn forgot-link"
              onClick={() => setView("forgot")}
            >
              Forgot Password?
            </button>

            <button type="submit" className="primary-btn">
              SIGN IN
            </button>
          </form>
        ) : (
          <form className="login-form" onSubmit={handleForgotSubmit}>
            <h1 className="form-heading">Forgot Password?</h1>

            <p className="form-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="form-label">User Email ID</label>

            <input
              type="email"
              name="forgotEmail"
              className="form-input"
              placeholder="Enter your Email ID"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            <button
              type="button"
              className="link-btn back-link"
              onClick={() => setView("login")}
            >
              <div className="back-link-content">
            <img
                src="/assets/log-arrow.png"
                alt="Back"
                className="back-arrow"
            />
            <span>Back to Login</span>
            </div>
            </button>

            <button type="submit" className="primary-btn">
              Send Reset Link
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;